export default "__VITE_ASSET__CwIJYU98__"